export const generateUrl = (order) => order.Sugestao ? generateUrlSuggestion(order) : generateUrlOrder(order)

const generateUrlSuggestion = (order) => `/stocksDetail/${order.IdFamiliaRotuladaCentro}/${order.Id}`

const generateUrlOrder = (order) => `/ordersVisionDetail/${order.Id}/${order.PedidoVolume ? 'V' : "P"}`;
